import {
  Body1,
  Label1,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@sainsburys-tech/fable'
import React from 'react'

import { ITemperatureData } from '../../types/ITemperatureData'

interface IProps {
  temperatures: ITemperatureData[]
}

const TemperatureCheckRow = (props: IProps) => {
  const getLabel = (i: number) => (i === 0 ? '1st' : i === 1 ? '2nd' : '3rd')

  return (
    <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
      <Table
        testid='temp-check-table'
        style={{ width: '100%' }}
        isStriped={false}
      >
        <TableBody>
          <TableRow>
            {props.temperatures.map((temperature, i) => (
              <TableCell
                key={`row-${i}`}
                className='temp-check-cell'
                style={{ minWidth: 80 }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '32px',
                  }}
                >
                  <Label1>{getLabel(i)}</Label1>
                  <Body1
                    className='c-hotfood-report-temp-check-col-value'
                    style={
                      parseFloat(temperature.temperature) < 75.0
                        ? { color: 'var(--fable-color-text-error, #a50000)' }
                        : undefined
                    }
                  >
                    {temperature.temperature}℃
                  </Body1>
                </div>
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </div>
  )
}

export default TemperatureCheckRow
